module.exports = __webpack_public_path__ + "img/ca_logo.1b9cf878.svg";